export default __webpack_public_path__ + "static/media/summer-wars.e49e91a8.jpg";